<template>

  <keep-alive>
    <router-view></router-view>
  </keep-alive>
  <!-- <MusicPlayer v-show="isFirstPage"/> -->
</template>
<style >
.modal-backdrop.fade.show {
  display: none !important;
}
</style>
<script>

export default {
  name: "App",
};
</script>
